import React from 'react'
import { closeEvolutionModal, isEvolutionModalOpen, openColumnEvolution } from 'Pages/AnalyzersV2/@tour/targets'
import { TourOverlay as BaseTourOverlay, default as VirtualTourButton } from 'Pages/Main/Home/VirtualTour'
import { TOUR_STEPS } from './steps'

// Back/dot navigation into the Evolution Chart step re-opens the column's evolution modal
const EVOLUTION_STEP = TOUR_STEPS.findIndex(s => s.id === 'evolution-chart')

const MODAL_RANGES = [
	{
		from: EVOLUTION_STEP, to: EVOLUTION_STEP,
		open: openColumnEvolution,
		close: closeEvolutionModal,
		isOpen: isEvolutionModalOpen,
	},
]

export function TourOverlay(props) {
	return <BaseTourOverlay {...props} modalRanges={MODAL_RANGES} />
}

export { TOUR_STEPS }
export default VirtualTourButton
